import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UiComponents, UnoStoreHooks, BackArrowIcon } from "@simulanisindia/ui";
import { checkPermissionExist, debounce } from "../../utils/general";
import apiClient from "../../apiClient";
import { CREATE_ROLE } from "../../apiClient/apiEndpoints";
import BtnLoad from "../../components/BtnLoad";
import PermissionsTab from "./PermissionsTab";
import { roleInfoTab, rolePermissionTab } from "../../utils/common";
import useSuccessfulModal from "../useSuccessfulModal";
import { ROLES_CREATE_PERMISSION } from "../../constant/permission";
import TabRole from "./TabRole";

const { SimListDropDown, BackButton } = UiComponents;
const { useUnoSelector } = UnoStoreHooks;

const CreateRole = ({ isMobileView }) => {
  const navigate = useNavigate();
  const handleOpenSuccessfulModal = useSuccessfulModal(1500, "Created Successfully.");
  const [activeTab, setActiveTab] = useState("#roleinfo");
  const configData = useUnoSelector((state) => state.config);
  const userData = useUnoSelector((state) => state.user);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectPermissions, setSelectPermissions] = useState([]);
  const [sideBarTab, setSideBarTab] = useState([]);
  const [errors, setErrors] = useState({
    name: null,
  });

  const backClick = () => navigate(-1);

  const handleResetData = () => {
    setName("");
    setDescription("");
    setSelectPermissions([]);
  };
  const handleResetError = () => {
    setErrors({
      name: null,
    });
  };

  useEffect(() => {
    let _permissionTabForPermissions = userData?.user?.permissions || [];
    const filteredRolePermissionTab = rolePermissionTab.map(tab => {
      let _tabSubmenuList = tab.submenu.filter(item => _permissionTabForPermissions.includes(item.key))
      return ({
        ...tab,
        id_link: _tabSubmenuList.length > 0 ? _tabSubmenuList[0].id_link : "",
        submenu: _tabSubmenuList
      })
    });

    setSideBarTab([...roleInfoTab, ...filteredRolePermissionTab])
  }, [configData]);




  const validateData = () => {
    let error = false;

    if (name.trim().length === 0) {
      error = true;
      setErrors((pre) => ({ ...pre, name: "kindly set name" }));
    }
    return error;
  };

  const handleCreateRole = async () => {
    if (loading) return;
    try {
      handleResetError();
      if (validateData()) return;
      setLoading(true);
      let bodyData = {
        name: name,
        description: description,
        permissions: selectPermissions,
      };
      await apiClient.post(`${configData.config.UNO_URL}${CREATE_ROLE}/${userData.user.group.uuid}`, bodyData);
      handleResetData();
      handleOpenSuccessfulModal();
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleRoleCreateDebounce = debounce(handleCreateRole, 500);

  return (
    <>
      <div className="newrole-page">
        <div className="page-title with-fuctions">
          <div className="title-here">
            <BackButton onBackClick={backClick} Icon={<BackArrowIcon />} />
            <h6>New Role</h6>
          </div>
          {checkPermissionExist(ROLES_CREATE_PERMISSION) && (
            <div className="search-parent">
              <button className="cancel" onClick={handleResetData}>
                Cancel
              </button>
              {loading ? (
                <button className="create">
                  {" "}
                  <BtnLoad />{" "}
                </button>
              ) : (
                <button onClick={handleRoleCreateDebounce} className="create">
                  {" "}
                  Create{" "}
                </button>
              )}
            </div>
          )}
        </div>
        <div className="newrole-card">
          <div className="newrole-sidebar">
            <SimListDropDown menuData={sideBarTab} setActiveTab={setActiveTab} activeTab={activeTab} />
          </div>
          <div className="newrole-content">
            {!isMobileView ? (
              <PermissionsTab
                errors={errors}
                heading="New Roles"
                activeTab={activeTab}
                name={name}
                setName={setName}
                description={description}
                setDescription={setDescription}
                selectPermissions={selectPermissions}
                setSelectPermissions={setSelectPermissions}
              />
            ) : (
              <TabRole
                errors={errors}
                heading="New Roles"
                selectedTab={activeTab}
                name={name}
                setName={setName}
                description={description}
                setDescription={setDescription}
                selectPermissions={selectPermissions}
                setSelectPermissions={setSelectPermissions}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateRole;
